import type { ProtectMerchantsPortalRouter } from "@src/backend/src/protect/functions/merchantsPortal";
import { useStytch } from "@stytch/react";
import { useQueryClient } from "@tanstack/react-query";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { PropsWithChildren, useState } from "react";
import { ProtectTRPCContextProvider } from "./trpc";

export function ProtectTRPCProvider({ children }: PropsWithChildren) {
  const stytch = useStytch();
  const queryClient = useQueryClient();

  const [trpcClient] = useState(() =>
    createTRPCClient<ProtectMerchantsPortalRouter>({
      links: [
        httpBatchLink({
          maxItems: 5,
          url: import.meta.env.VITE_PROTECT_TRPC_API_URL,
          async headers() {
            return {
              authorization: stytch.session.getTokens()?.session_token,
            };
          },
        }),
      ],
    })
  );

  return (
    <ProtectTRPCContextProvider
      trpcClient={trpcClient}
      queryClient={queryClient}
    >
      {children}
    </ProtectTRPCContextProvider>
  );
}
